var map = {
	"./ar.png": "33c7",
	"./by.png": "73de",
	"./en.png": "1409",
	"./fr.png": "d86f",
	"./he.png": "6bf3",
	"./ko.png": "42c7",
	"./kz.png": "5f4a",
	"./ru.png": "aad4",
	"./tr.png": "1af2",
	"./ua.png": "c61f",
	"./uz.png": "d9d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f202";